import React, {Component} from 'react';
import {connect} from 'react-redux';
import UserBox from "../Helpers/User/UserBox";
import qs from 'qs';
import HTML from '../Helpers/HTML';
import Image from './ChatWindow/MessageTypes/Image';
import axios from 'axios';
import Loading from '../Loading';
import history from '../../history';
import UrlPusher from "../Helpers/UrlPusher";
import { makeObservable, observable } from "mobx";
import { observer, inject } from "mobx-react";

//actions
import appendChatOpenedWindows from '../../actions/chat/appendChatOpenedWindows';
import setChatState from '../../actions/chat/setChatState';


class ChatMessagesSearch extends Component {
  fetching=false;
  inited=false;
  data=null;
  selected=undefined;

  constructor(props) {
    super(props);
    makeObservable(this,{
      fetching:observable,
      inited:observable,
      data:observable,
      selected:observable,
    });

    this.state={
      fetching:false,
      inited:false,
      data:null,
      selected:undefined,
    }
  }
  searchMessages() {
    const q=qs.stringify({ filter:{ '~message':`%${this.props.query.replace(/ /g,"%")}%` } });
    this.setState({ fetching:true });
    axios.get(`/api/privatechat/0/search?${q}`).then((data)=>{
      this.setState({
        selected:undefined,
        fetching:false,
        inited:true,
        data:data.data.answer.items,
      });
    });
  }
  componentDidMount() {
    this.searchMessages();
  }
  selectMe(index) {
    const item = this.state.data[index];
    if(this.props.standalone) {
      history.push(`/chat/${item.chat_id}/${item.id}`);
    } else {
      console.log('selected!', item);
      this.props.setChatState({win: null, chat_options: {[item.chat_id]: {message_id: item.id}}});
      this.props.appendChatOpenedWindows(item.chat_id);
    }
  }
  keyDown(e) {
    const keyId = e.which;
    console.log('keyId', keyId);
    //up 38, down 40, enter 13
    let setSelected = 'not_set';
    switch (keyId) {
      case 38: //up
        e.preventDefault();
        if (typeof this.state.selected === 'undefined') {
          setSelected = this.state.data.length - 1;
        } else {
          setSelected = this.state.selected - 1;
        }
        break;
      case 40: //down
        e.preventDefault();
        if (typeof this.state.selected === 'undefined') {
          setSelected = 0;
        } else {
          setSelected = this.state.selected + 1;
        }
        break;
      case 13: //enter
        e.preventDefault();
        if (typeof this.state.selected !== 'undefined') {
          this.selectMe(this.state.selected);
        }
        break;
      case 8: //backspace?

        break;
    }
    if (setSelected !== 'not_set') {
      if (setSelected > this.state.data.length - 1) {
        setSelected = this.state.data.length - 1;
      }
      if (setSelected < 0) {
        setSelected = 0;
      }
      this.setState({selected: setSelected});
    }
  }

  /*
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.query !== prevProps.query) {
      this.searchMessages();
    } else {
      if (!this._itemRef && this._wrapRef) {
        this._wrapRef.scrollTop = 0;
      }
      if (this._itemRef && this._wrapRef) {
        //scroll controll
        let wrapRect = this._wrapRef.getBoundingClientRect();
        let itemRect = this._itemRef.getBoundingClientRect();

        const summUp = itemRect.top - wrapRect.top;
        const summDown = itemRect.top + itemRect.height - wrapRect.top - wrapRect.height;

        if (summDown > 0) {
          this._wrapRef.scrollTop += summDown;// * (-1);
        }
        if (summUp < 0) {
          this._wrapRef.scrollTop += summUp;// * (-1);
        }
      }
    }
  }
  */
  renderMessage(item) {
    if (item.type === 'text') {
      return (
        <UrlPusher>
          <HTML>{item.message}</HTML>
        </UrlPusher>
      )
    }
    if (item.type === 'image') {
      return (
        <div>
          <Image reScroll={() => { }} item={item}/>
          {item.message ? (
            <div className="ptop4">
              <UrlPusher>
                <HTML>{item.message}</HTML>
              </UrlPusher>
            </div>
          ) : null}
        </div>
      )
    }
  }
  renderMessages() {
    if(!this.state.inited) {
      return (
        <Loading />
      )
    }
    if(this.state.data) {
      return this.state.data.map((item,index) => {
        const addProps = {};
        return (
          <div className={` vpadd5 pointer hpadd10 ${this.state.selected === index?'bg-pc1-op80':''}`} ref={(ref)=>{  if(index===this.state.selected){ this._itemRef=ref; } }} onClick={(e) => {
            e.preventDefault();
            this.selectMe(index);
          }} key={item.id} {...addProps}>
            <div className="up12 s-nowrap splice">
              <div className="cell s-shrink">
                <UserBox
                  avatar={item.user_table_avatar}
                  nick={item.user_table_nick}
                  size={30}
                />
              </div>
              <div className="cell s-auto pleft5">
                <div className={`fs13 padd5 rad3 pr bg-w2 wordBreak`}>
                  <div className="otherTriangle pa"></div>
                  <div className="pc1">{item.user_table_nick}</div>
                  {this.renderMessage(item)}
                </div>
              </div>
            </div>
          </div>
        );
      });
    }
  }
  render() {
    return (
      <div className="ofa h100" ref={(ref)=>{ this._wrapRef=ref; }}>
        {this.renderMessages()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

// export default connect(mapStateToProps, { appendChatOpenedWindows,setChatState },null,{ withRef:true })(ChatMessagesSearch);
export default observer(ChatMessagesSearch);